import { backendManagement } from "../backendPlatform";

export const checkUserExists = (data) => {
  return backendManagement.post("users/exists", data);
};